import { SyncOutlined } from "@ant-design/icons";
import { Button, Form } from "antd";
import { FC } from "react";
import { CustomBtnProps } from "../models/custom_btn_props";

const CustomButton: FC<CustomBtnProps> = ({ wrapperClass, btnType, btnClass, btnText, disabled, loading }) => {

    return (
        <div className={`${wrapperClass}`}>
            <Form.Item label={null}>
                <Button type={"primary"} htmlType="submit" className={`btn ${btnClass}`} disabled={disabled}>
                    {btnText} {loading && <SyncOutlined spin/>}
                </Button>
            </Form.Item>
        </div>
    );
};

export { CustomButton };
